import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type RecordIconProps = {
  size?: number
  color?: string
  className?: string
}

export const RecordIcon = ({
  size = 14,
  color = tokenVar('colors.status.error'),
  className,
}: RecordIconProps) => (
  <svg
    aria-label='Record'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 14 14'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='7' cy='7' fill={color} r='5' />
  </svg>
)
